import classNames from "classnames";
import * as React from "react";

type ClsAndChildProps = {className?: string; children?: React.ReactNode};

export const D3 = ({className, children}: ClsAndChildProps) => {
    return <div className={classNames('d3', className)}>{children}</div>;
};
